import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ComparisonTable = () => {
  const { t } = useTranslation();

  // Define features array directly to ensure proper typing
  const features = [
    t('landing.comparison.features.0'),
    t('landing.comparison.features.1'),
    t('landing.comparison.features.2'),
    t('landing.comparison.features.3'),
    t('landing.comparison.features.4'),
    t('landing.comparison.features.5'),
    t('landing.comparison.features.6'),
    t('landing.comparison.features.7')
  ];

  const providers = [
    {
      name: 'Gmail',
      features: [false, false, true, false, false, false, false, false],
      highlight: false,
    },
    {
      name: 'Temp Mail',
      features: [false, false, false, false, true, false, false, false],
      highlight: false,
    },
    {
      name: 'Uumail',
      features: [true, true, true, true, true, true, true, true],
      highlight: true,
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('landing.comparison.title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('landing.comparison.subtitle')}
          </p>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="text-left p-4 border-b-2 border-gray-200"></th>
                {providers.map((provider, index) => (
                  <th 
                    key={index} 
                    className={`p-4 border-b-2 ${
                      provider.highlight 
                        ? 'bg-blue-50 border-blue-500 text-blue-600' 
                        : 'border-gray-200 text-gray-700'
                    }`}
                  >
                    {provider.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feature, featureIndex) => (
                <tr key={featureIndex} className="hover:bg-gray-50">
                  <td className="p-4 border-b border-gray-200 font-medium text-gray-700">
                    {feature}
                  </td>
                  {providers.map((provider, providerIndex) => (
                    <td 
                      key={providerIndex} 
                      className={`p-4 border-b border-gray-200 text-center ${
                        provider.highlight ? 'bg-blue-50' : ''
                      }`}
                    >
                      {provider.features[featureIndex] ? (
                        <Check className="h-5 w-5 text-green-500 mx-auto" />
                      ) : (
                        <X className="h-5 w-5 text-red-500 mx-auto" />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;